import { gql } from "lib/apolloClient";
import {
  unitFlowFragment,
  unitResourceFragment,
  unitFlowFragmentWithoutDepth,
} from "./Fragments";

export const createEntityFlowResourceMutation = gql`
  mutation createEntityFlowResource(
    $input: EntityFlowResourceCreateInput!
    $filters: EntityFlowResourceFilter
  ) {
    planner {
      createEntityFlowResource(input: $input) {
        ...unitFlowWithChildrenItem
      }
    }
  }
  ${unitFlowFragmentWithoutDepth.unitFlowWithChildren}
`;

export const reorderEntityFlowResourceMutation = gql`
  mutation reorderEntityFlowResource($input: EntityFlowResourceReorderInput!) {
    planner {
      reorderEntityFlowResource(input: $input)
    }
  }
`;

export const updateEntityFlowResourceMutation = gql`
  mutation updateEntityFlowResource($input: EntityFlowResourceUpdateInput!) {
    planner {
      updateEntityFlowResource(input: $input) {
        id
      }
    }
  }
`;

export const deleteEntityFlowResourceMutation = gql`
  mutation deleteEntityFlowResource($input: EntityFlowResourceDeleteInput!) {
    planner {
      deleteEntityFlowResource(input: $input)
    }
  }
`;

export const repeatEntityFlowResourceMutation = gql`
  mutation repeatEntityFlowResource(
    $input: RepeatEntityFlowResourceInput!
    $filters: EntityFlowResourceFilter
  ) {
    planner {
      repeatEntityFlowResource(input: $input) {
        isSuccess
        error
        entityFlowResource {
          ...unitFlowWithChildrenItem
        }
      }
    }
  }
  ${unitFlowFragment.unitFlowWithChildren}
`;

export const importEntityFlowResourceMutation = gql`
  mutation importEntityFlowResource(
    $input: ImportEntityFlowResourceInput!
    $filters: EntityFlowResourceFilter
  ) {
    planner {
      importEntityFlowResource(input: $input) {
        isSuccess
        error
        entityFlowResource {
          ...unitFlowWithChildrenItem
        }
      }
    }
  }
  ${unitFlowFragment.unitFlowWithChildren}
`;

export const createUnitResourceMutation = gql`
  mutation createEntityFlowResource($input: EntityFlowResourceCreateInput!) {
    planner {
      createEntityFlowResource(input: $input) {
        ...unitResourceItem
      }
    }
  }
  ${unitResourceFragment}
`;
